import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import BackContainer from '../seller/components/backContainer';
import EventCard from './components/eventCard';
import { Button } from '../../ui';
import formattedAmount from '../seller/components/utils';
import Timer from './components/timer';
import CommandDetails from './components/commandDetails';
import Message from '../../jo-components/misc/message/message'
import './ticket.css';


function TotalDetails({text, amount, currency, className=''}) {
    if (typeof amount !== 'number')
        return <></>;

    return (
        <div className='wz-fees-line'>
            <div className={`wz-fees ${className}`}>{text}</div>
            <div className={`wz-fees ${className}`}>{formattedAmount(amount, currency)}</div>
        </div>
    )
}

export default function TicketCart({onSubmit = () => {}, config}) {
    const { t } = useTranslation();

    const data = config['ticket-market-confirm'];
    const { header, total_htc, total_fees} = data;
    const currency = data.event.currency;

    const browseTree = React.useCallback((tree) => {
        let _quantity = 0;
        tree.forEach(item => {
            if (item.quantity) {
                _quantity += item.quantity;
            }

            if (item.rates) {
                _quantity += browseTree(item.rates);
            }
        });
        return _quantity;
    },[])

    const totalTickets = React.useMemo(() => {
        let all_tickets = browseTree(data.root);
        data.rates_without_group.forEach(rate => {
            all_tickets += rate.quantity;
        })
        return all_tickets;
    }, [data]);

    const goBackToEventList = React.useCallback(() => {
        window.location.reload()
    }, []);

    return (
        <div className='wz-event-content'>
            <div>
                <EventCard event={data.event}/>
                <div className='wz-rates-container'>
                    {header ? 
                        <Message title={header.title} description={header.description} type={'warning'}/> 
                        : 
                        <BackContainer title={t('widget.resale.cart.cta-back')} onClick={goBackToEventList}/>
                    }
                    <div className='wz-tickets-title'>{t('widget.resale.cart.title')}</div>
                    <Timer/>
                    <div className='wz-tickets-tickets-recap'>
                        <Trans i18nKey="widget.resale.cart.tickets-recap" values={{count: totalTickets}} />
                    </div>
                    {
                        data.root.map((group) => <CommandDetails group={group} rates={group.rates} currency={currency}/>)
                    }
                    {data.rates_without_group.length > 0 && <CommandDetails rates={data.rates_without_group} currency={currency}/>}
                    <TotalDetails className='wz-subtotal' text={t('widget.resale.cart.subtotal')} currency={currency} amount={total_htc}/>
                    <TotalDetails text={t('widget.resale.cart.service_fees')} currency={currency} amount={total_fees}/>
                    <TotalDetails className='wz-total-cart' text={t('widget.resale.cart.total')} currency={currency} amount={data.total_ttc}/>
                    <div className='wz-cta-container'>
                        <Button className='wz-cta-next' onClick={onSubmit} label={t('widget.resale.cart.cta-checkout')}/>
                    </div>
                </div>
            </div>
        </div>
    )

}